module.exports = __webpack_public_path__ + "static/media/landing_page_video_2k.3b734a61.mp4";